export default __webpack_public_path__ + "static/media/skip_answer.2eaee227.svg";